import React from "react";
import outOfStockIcon from "../../../../assets/out-of-stock-icon.svg";
import { useAppSelector } from "../../../../store/hooks";
const NoMoreQuantity = ({ isOpen, onClose }) => {
  const { isPartsURL, isAccessoriesURL } = useAppSelector(
    (state) => state.domain
  );
  
  if (!isOpen[0]) return null;
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="out-of-stock-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-icon-invalid-barcode">
          <img src={outOfStockIcon} alt="Out of Stock" />
        </div>

        <h2 className="modal-title-invalid-barcode">No more quantity available.</h2>
        <p className="modal-message-invalid-barcode">
          Only {isOpen[1]} units available in stock for {isOpen[2]}
        </p>
        <button
          className={
            isPartsURL
              ? "modal-ok-btn-parts"
              : isAccessoriesURL
              ? "modal-ok-btn-acc"
              : "modal-ok-btn"
          }
          onClick={onClose}
        >
          Ok
        </button>
      </div>
    </div>
  );
};

export default NoMoreQuantity;
